/* eslint-disable */
import request from 'superagent';

export const getPages = () => {
    return new Promise((resolve, reject) => {
        return request
            .get('https://us-central1-same-same-2cb4a.cloudfunctions.net/app/pages')
            .set('Content-Type', 'application/json')
            .then(res => {
                return resolve(res);
            })
            .catch(err => {
                return reject(err);
            });
    });
};

export const submitForm = (data) => {
    return new Promise((resolve, reject) => {
        return request
            .post('https://us-central1-same-same-2cb4a.cloudfunctions.net/app/enquiry')
            .set('Content-Type', 'application/json')
            .send(data)
            .then(res => {
                return resolve(res);
            })
            .catch(err => {
                return reject(err);
            });
    });
};

export const getApi = (path, paramters = {}) => {
    return new Promise((resolve, reject) => {
        return request
            .get(`/${path}`)
            .set('Content-Type', 'application/json')
            .query(paramters)
            .then(res => {
                return resolve(res);
            })
            .catch(err => {
                return reject(err);
            });
    });
};

export const postApi = (path, data) => {
    return new Promise((resolve, reject) => {
        return request
            .post(`/${path}`)
            .set('Content-Type', 'application/json')
            .send(data)
            .then(res => {
                return resolve(res);
            })
            .catch(err => {
                return reject(err);
            });
    });
};

export const putApi = (path, data) => {
    return new Promise((resolve, reject) => {
        return request
            .put(`/${path}`)
            .set('Content-Type', 'application/json')
            .send(data)
            .then(res => {
                return resolve(res);
            })
            .catch(err => {
                return reject(err);
            });
    });
};

export const deleteApi = (path, data) => {
    return new Promise((resolve, reject) => {
        return request
            .delete(`/${path}`)
            .set('Content-Type', 'application/json')
            .send(data)
            .then(res => {
                return resolve(res);
            })
            .catch(err => {
                return reject(err);
            });
    });
};



// WEBPACK FOOTER //
// ./src/modules/api.js